import { CalendarLight } from '@ha/icons';
import React from 'react';
import loadable from '@loadable/component';
import { useSelector } from 'react-redux';

import { useIntl } from 'ha/i18n';
import { useMediaQuery } from 'ha/helpers/MediaQuery';
import FilterOverlay from 'ha/components/Filters/FilterOverlay';
import { formatDateRange } from '@ha/date';
import { Button } from '@ha/dsl';

import { getDateFilter } from '../../selectors';

const SearchDateFilterContentLazy = loadable(
  () => import('./SearchDateFilterContent'),
);

const SearchDateFilterNext: React.FC = () => {
  const { T, formatDate } = useIntl();

  const { md } = useMediaQuery();

  const { startDate, endDate } = useSelector(getDateFilter);

  const isActive = Boolean(startDate);

  const [open, setOpen] = React.useState(false);

  const handleOpen = React.useCallback(async () => {
    await SearchDateFilterContentLazy.load();

    setOpen(true);
  }, []);
  const handleClose = React.useCallback(() => {
    setOpen(false);
  }, []);

  const [anchorEl, setAnchorEl] = React.useState<HTMLButtonElement | null>(
    null,
  );

  return (
    <React.Fragment>
      <Button
        variant={isActive ? 'contained' : 'outlined'}
        color="primary"
        size={md ? 'medium' : 'small'}
        ref={md ? setAnchorEl : undefined}
        onClick={handleOpen}
        startIcon={!md && <CalendarLight fontSize="small" />}
        data-test-locator="Date Filter Button"
        id="date-filter"
      >
        {isActive && !endDate && `${T('From')} `}
        {isActive && formatDateRange(formatDate, startDate, endDate)}
        {!isActive && T('Dates')}
      </Button>
      <FilterOverlay
        open={open}
        onClose={handleClose}
        {...(md ? { type: 'popover', anchorEl } : { type: 'dialog' })}
      >
        <SearchDateFilterContentLazy onShowResultsClick={handleClose} />
      </FilterOverlay>
    </React.Fragment>
  );
};

export default SearchDateFilterNext;
